import { render, staticRenderFns } from "./SportWatchNowButton.vue?vue&type=template&id=3b5b643f&scoped=true&"
import script from "./SportWatchNowButton.vue?vue&type=script&lang=ts&"
export * from "./SportWatchNowButton.vue?vue&type=script&lang=ts&"
import style0 from "./SportWatchNowButton.vue?vue&type=style&index=0&id=3b5b643f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5b643f",
  null
  
)

export default component.exports